import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../helpers/state.helper';
import ModuleService from '../../services/module.service';

const initialState = {
  modulesSettings: {},
  modulesTypes: [],
  modulesDashboard: [],
  pages: [],
  pagesSettings: {},
  customLinks: [],
  youtube: [],
  vimeo: [],
};

const linksModules = [ModuleService.TYPE_LINK, ModuleService.TYPE_VIMEO, ModuleService.TYPE_YOUTUBE, ModuleService.TYPE_PAGE];

const setModules = (state, action) => {
  const { payload } = action;
  const modulesTypes = payload.map(module => module.type);
  const modulesDashboard = payload.filter(module => module.show_on_portal || linksModules.indexOf(module.type) > -1)
    .map(module => module.type);
  const modulesSettings = {};
  for (let i = 0; i < payload.length; i++) {
    const module = payload[i];
    modulesSettings[module.type] = { ...module, commented: !!(module.params && module.params.commented) };
  }
  return {
    ...state,
    modulesSettings,
    modulesTypes,
    modulesDashboard,
  };
};

const setPagesLinks = (state, action) => {
  const { payload } = action;
  const pagesSettings = {};
  const pages = payload.filter(page => page.permalink)
    .map(page => page.permalink);
  for (let i = 0; i < payload.length; i++) {
    if (payload[i].permalink) pagesSettings[payload[i].permalink] = payload[i];
  }
  return {
    ...state,
    pages,
    pagesSettings,
  };
};

const setCustomLinks = (state, action) => {
  const { payload } = action;
  const customLinks = payload.map(link => ({ custom_icon: link.custom_icon, path: link.url, name: link.title, color: link.color, image: link.image, text_color_class: link.text_color_class }));
  return {
    ...state,
    customLinks,
  };
};

const setYoutube = (state, action) => {
  const { payload } = action;
  const youtube = payload.map(link => ({ path: link.url, name: link.title, color: link.color, image: link.image, text_color_class: link.text_color_class }));
  return {
    ...state,
    youtube,
  };
};

const setVimeo = (state, action) => {
  const { payload } = action;
  const vimeo = payload.map(link => ({ path: link.url, name: link.title, color: link.color, image: link.image, text_color_class: link.text_color_class }));
  return {
    ...state,
    vimeo,
  };
};

const reducer = handleActions(
  {
    [types.SET_MODULES]: setModules,
    [types.CLEAR_MODULES]: mergeIn(() => initialState),
    [types.SET_PAGES_LINKS]: setPagesLinks,
    [types.CLEAR_PAGES_LINKS]: mergeIn(() => initialState),
    [types.SET_CUSTOM_LINKS]: setCustomLinks,
    [types.SET_YOUTUBE]: setYoutube,
    [types.SET_VIMEO]: setVimeo,
  },
  initialState,
);

// setCustomLinks,
//   setPagesLinks,
//   clearCustomLinks,
//   clearPagesLinks,

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/modules/reducers.js